/**
 * Returns true if the array items are unique
 *
 * @param arr - The array
 * @returns Boolean
 */
export function isArrayUnique(arr: unknown[]): boolean {
    return new Set(arr).size === arr.length;
}
